const RENDER_STATE_NAMES = new Set(['render-template', 'render-dynamic']);

export default class QueryParamService {
  constructor($location, $state) {
    'ngInject';
    Object.assign(this, {$location, $state});
  }

  // Render routes store query params on ui-router state, not $location.search.
  usesStateParams() {
    return RENDER_STATE_NAMES.has(this.$state?.current?.name);
  }

  // Read from $state.params on render routes; otherwise use $location.search.
  getRawParam(paramName) {
    if (this.usesStateParams()) {
      const fromState = this.$state.params?.[paramName];
      if (fromState != null && fromState !== '') return fromState;
    }
    return this.$location.search()[paramName];
  }

  // On render routes, replace state params in-place so the URL updates without reloading.
  setRawParam(paramName, newValue) {
    if (this.usesStateParams()) {
      const route = this.$state.current.name;
      const params = { ...this.$state.params, [paramName]: newValue };
      if (newValue == null || newValue === '') delete params[paramName];
      return this.$state.go(route, params, {
        inherit: false,
        notify: false,
        reload: false,
        location: 'replace',
      });
    }
    return this.$location.search(paramName, newValue);
  }

  getParsedParam(paramName) {
    return this.decodeParam(this.getRawParam(paramName));
  }
  
  decodeParam(obj) {
    return JSON.parse(decodeURIComponent(obj || "{}"));
  }

  encodeValue(obj) {
    return JSON.stringify(obj || {});
  }
}
